import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function switchSessionHeldPlace({
  appointmentId,
  placeValue,
  appointmentHeldPlace,
  externalMeetingLink,
  sessionRecordingType,
  sessionRecordingSource,
  onBehalfOf,
}: {
  appointmentId: string | number;
  placeValue: string;
  appointmentHeldPlace: string | null;
  externalMeetingLink: string | null;
  sessionRecordingType?: string | null;
  sessionRecordingSource?: string | null;
  onBehalfOf?: string;
}) {
  const queryParams = new URLSearchParams();

  if (appointmentHeldPlace) {
    queryParams.append("place", appointmentHeldPlace);
  }

  if (externalMeetingLink) {
    queryParams.append("external_meeting_link", externalMeetingLink);
  }

  if (placeValue !== "orchid" && sessionRecordingType) {
    queryParams.append("session_recording_type", sessionRecordingType);
  }

  if (placeValue !== "orchid" && sessionRecordingSource) {
    queryParams.append("session_recording_source", sessionRecordingSource);
  }

  if (onBehalfOf) {
    queryParams.append("on_behalf_of", onBehalfOf);
  }

  const response = await fetchOrchidAPI(
    `/api/scheduler/v1/appointment/admin/held_outside_of_orchid/${appointmentId}/${placeValue}${
      queryParams.toString() ? `?${queryParams.toString()}` : ""
    }`,
    { method: "POST" },
  );

  if (!response.ok) {
    const responseText = await response.text();
    throw new Error(getErrorDetail(responseText));
  }

  return;
}
